import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum State {
	Waitlisted = 'waitlisted',
	Invited = 'invited',
	Booked = 'booked',
	Declined = 'declined',
}

export interface FormEventGroupWaitlistEntry extends Record, Dateable {
	formEventGroupId: number;
	submittedForUserId: number;
	submittedByUserId: number;
	state: State;
}

export interface EntryRef {
	id: number;
	formEventGroupId: number;
	state: State;
}

export interface WaitlistRowMeta {
	submittedForUserId: number;
	state: State;
	otherWaitingEntries: EntryRef[];
	// Whether an invite to this child would go through, the API's own invite refusal.
	canInvite: boolean;
	// The child's account is archived: listed, but counted in no waitlistFigures.
	archived: boolean;
}
